import * as Yup from "yup";

export const referralSchema = Yup.object().shape({
  service_needed: Yup.string().required("Service name is required"),
  advocate_id: Yup.string().when("isAddingNewAdvocate", {
    is: false,
    then: (schema) => schema.required("Advocate is required"),
  }),
  advocate_name: Yup.string().when("isAddingNewAdvocate", {
    is: true,
    then: (schema) => schema.required("Advocate name is required"),
  }),
  advocate_phone: Yup.string().when("isAddingNewAdvocate", {
    is: true,
    then: (schema) =>
      schema
        .required("Phone number is required")
        .matches(
          /^\(\d{3}\) \d{3}-\d{4}$/,
          "Please enter a valid phone number: (XXX) XXX-XXXX",
        )
        .test(
          "is-complete",
          "Please enter a complete phone number",
          (value) => {
            if (!value) return false;
            const digitCount = value.replace(/\D/g, "").length;
            return digitCount === 10;
          },
        ),
  }),
  signup_source_id: Yup.string(),
  signup_source_type: Yup.string(),
  customer_name: Yup.string(),
  customer_phone: Yup.string()
    .required("Phone number is required")
    .matches(
      /^\(\d{3}\) \d{3}-\d{4}$/,
      "Please enter a valid phone number: (XXX) XXX-XXXX",
    )
    .test("is-complete", "Please enter a complete phone number", (value) => {
      if (!value) return false;
      const digitCount = value.replace(/\D/g, "").length;
      return digitCount === 10;
    }),
  isAddingNewAdvocate: Yup.boolean(),
  onboard: Yup.boolean(),
});

export const initialValues = {
  service_needed: "",
  advocate_id: "",
  advocate_name: "",
  advocate_phone: "",
  signup_source_id: "none",
  signup_source_type: "none",
  customer_name: "",
  customer_phone: "",
  isAddingNewAdvocate: false,
  onboard: false,
};

export type AddReferralFormValues = typeof initialValues;
